import { useTodayPendingAbsences } from '@data';
import React, { ReactElement, ReactNode, useMemo } from 'react';

import { PendingAbsencesContext } from './pendingAbsences';

/** Gives the day cards below it this member's time off from Officient that is still to be filed today. */
const PendingAbsencesProvider = ({
  organizationId,
  userId,
  children,
}: {
  organizationId: string;
  userId: string | undefined;
  children: ReactNode;
}): ReactElement => {
  const todayDate = useMemo(() => new Date(), []);
  const pendingAbsences = useTodayPendingAbsences(organizationId, userId, todayDate);

  return <PendingAbsencesContext.Provider value={pendingAbsences}>{children}</PendingAbsencesContext.Provider>;
};

export default PendingAbsencesProvider;
